import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from './lang'
import axios from 'axios'
import store from 'store'

Vue.use(VueI18n)

let storedLang = store.get('lang') || 'en'

export const i18n = new VueI18n({
  locale: storedLang,
  fallbackLocale: 'en',
  messages
})

const loadedLanguages = ['en'] // our default language that is prelaoded

export function setI18nLanguage (lang) {
  i18n.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export function loadLanguageAsync (lang) {
  if (i18n.locale !== lang) {
    if (!loadedLanguages.includes(lang)) {
      return import(/* webpackChunkName: "lang-[request]" */ `./lang/${lang}`).then(msgs => {
        i18n.setLocaleMessage(lang, msgs.default)
        loadedLanguages.push(lang)
        return setI18nLanguage(lang)
      })
    }
    return Promise.resolve(setI18nLanguage(lang))
  }
  return Promise.resolve(lang)
}

export function getCurrentLanguage () {
  return i18n.locale
}